import { GradientButton, colorsPalette, styled } from '@lingoda/ui';

export const BookClassesRoundButton = styled(GradientButton)(({ theme }) => ({
    fontSize: 'inherit',
    borderRadius: '10em',
    height: '40px',
    paddingTop: '0',
    paddingBottom: '0',

    '& .MuiSvgIcon-root.MuiSvgIcon-root': {
        fontSize: '1em',
    },

    '&::before': {
        background: colorsPalette.whiteSolid[100],
        borderRadius: 'inherit',
        transition: 'none',
    },

    '&:hover': {
        '&::before': {
            background: theme.palette.gradients.purpleToPrimaryFlattenedAlpha,
        },
    },
}));
